import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

const NETWORKS = [
  {
    name: "Facebook",
    color: "#1877F2",
    href: (u, t) => `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    path: "M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z",
  },
  {
    name: "X",
    color: "#000000",
    href: (u, t) => `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
    path: "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z",
  },
  {
    name: "Pinterest",
    color: "#BD081C",
    href: (u, t) => `https://pinterest.com/pin/create/button/?url=${u}&description=${t}`,
    path: "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.764-1.379l-.751 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z",
  },
  {
    name: "LinkedIn",
    color: "#0A66C2",
    href: (u, t) => `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
    path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z",
  },
  {
    name: "Reddit",
    color: "#FF4500",
    href: (u, t) => `https://www.reddit.com/submit?url=${u}&title=${t}`,
    path: "M24 11.779c0-1.459-1.192-2.645-2.657-2.645-.715 0-1.363.286-1.84.746-1.81-1.191-4.259-1.949-6.971-2.046l1.483-4.669 4.016.941-.006.058c0 1.193.975 2.163 2.174 2.163 1.198 0 2.172-.97 2.172-2.163s-.975-2.164-2.172-2.164c-.92 0-1.704.574-2.021 1.379l-4.329-1.015c-.189-.046-.381.063-.44.249l-1.654 5.207c-2.838.034-5.409.798-7.3 2.025-.474-.438-1.103-.712-1.799-.712-1.465 0-2.656 1.187-2.656 2.646 0 .97.533 1.811 1.317 2.271-.052.282-.086.567-.086.857 0 3.911 4.808 7.093 10.719 7.093s10.72-3.182 10.72-7.093c0-.288-.033-.571-.084-.853.789-.46 1.323-1.303 1.323-2.275zm-17.226 1.674c0-.92.749-1.671 1.671-1.671.92 0 1.667.752 1.667 1.671 0 .919-.747 1.665-1.667 1.665-.922 0-1.671-.746-1.671-1.665zm9.578 4.674c-1.097.745-2.83 1.379-4.34 1.379s-3.243-.634-4.34-1.379c-.231-.157-.29-.471-.132-.701.157-.23.471-.288.701-.131.882.598 2.359 1.143 3.771 1.143s2.889-.545 3.771-1.143c.23-.157.544-.099.701.132.158.229.099.543-.132.7zm-3.234-5.328c-.92 0-1.671.746-1.671 1.665 0 .919.751 1.665 1.671 1.665.922 0 1.671-.746 1.671-1.665 0-.919-.749-1.665-1.671-1.665z",
  },
];

export default function ShareBar({ url, title }) {
  const [copied, setCopied] = useState(false);
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title ? `Check out this custom medal: ${title} — Lane4` : "Custom medals by Lane4");

  const openShare = (href) => {
    window.open(href, "_blank", "noopener,noreferrer,width=600,height=600");
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <div className="flex items-center justify-center gap-2 mt-3" data-testid="share-bar">
      {NETWORKS.map((n) => (
        <button
          key={n.name}
          type="button"
          onClick={() => openShare(n.href(u, t))}
          aria-label={`Share on ${n.name}`}
          title={`Share on ${n.name}`}
          className="w-9 h-9 rounded-full flex items-center justify-center text-white hover:opacity-85 transition-opacity"
          style={{ backgroundColor: n.color }}
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d={n.path} />
          </svg>
        </button>
      ))}
      <button
        type="button"
        onClick={copyLink}
        aria-label="Copy link"
        title="Copy link"
        className="h-9 px-3 rounded-full flex items-center gap-1.5 bg-gray-200 text-[#0F2137] hover:bg-gray-300 transition-colors text-sm font-medium"
      >
        {copied ? <Check size={16} /> : <Copy size={16} />}
        {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
}
